














































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import TandaVital from "@/components/pemeriksaan/assesmen/asesmenkeperawatan/TandaVital.vue";
import Fungsional from "@/components/pemeriksaan/assesmen/asesmenkeperawatan/Fungsional.vue";
import Nyeri from "@/components/pemeriksaan/assesmen/asesmenkeperawatan/Nyeri.vue";
import Keluhan from "@/components/pemeriksaan/assesmen/Keluhan.vue";
import Alergi from "@/components/pemeriksaan/assesmen/Alergi.vue";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import RisikoJatuh from "@/components/pemeriksaan/assesmen/RisikoJatuh.vue";
import PerawatAutoComplete from "@/components/pemeriksaan/assesmen/PerawatAutoComplete.vue";
import BeratBadan from "@/components/pemeriksaan/assesmen/BeratBadan.vue";
import TinggiBadan from "@/components/pemeriksaan/assesmen/TinggiBadan.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import moment from "moment";
import storeAsesmenKemoterapi from "@/store/modules/AsesmenKemoterapi";
import SvcAsesmenKemoterapi from "@/services/AsesmenKemoterapi";
import FormPrefillService from "@/services/FormPrefillService";
import {
  composeDate,
  toDateString,
  toTimeString,
} from "@/utils/asesmenIntensifDateTime";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";

@Component({
  components: {
    TandaVital,
    BeratBadan,
    TinggiBadan,
    VCDateTimePicker,
    PerawatAutoComplete,
    Fungsional,
    Keluhan,
    Nyeri,
    Alergi,
    RisikoJatuh,
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardAssesmenKemoterapi extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop() showBtn!: boolean;
  @Prop() showRiwayat!: boolean;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }
  sess_login = userModule.user;
  loading = false;
  id = null;
  time = moment().format("HH:mm:ss");
  today = moment().format("YYYY-MM-DD");
  maxDate = moment().format("YYYY-MM-DD");
  waktuPeriksa = this.today + " " + this.time;
  tarikTtvLoading = false;

  get waktuPeriksaDate(): Date | null {
    const w = this.waktuPeriksa || "";
    return composeDate(w.slice(0, 10), w.slice(11, 16));
  }
  set waktuPeriksaDate(val: Date | null) {
    const tgl = toDateString(val);
    if (!tgl) {
      return;
    }
    this.waktuPeriksa = tgl + " " + toTimeString(val) + ":00";
  }
  diagnosa = null;
  tindakan = null; // tindakan rawat jalan
  ranap = null;
  siklus = null;
  keluhan = null;
  setKeluhan(v) {
    this.keluhan = v;
  }
  alergi = this.statePasien ? this.statePasien.alergi : null;
  setAlergi(v) {
    this.alergi = v;
  }
  tandaVital = {
    id: null,
    sistole: null,
    diastole: null,
    frekuensi_nadi: null,
    frekuensi_nafas: null,
    suhu_badan: null,
    saturasi_oksigen: null,
    keadaan_umum: "",
    kesadaran: "",
  };
  getTandaVital(val) {
    this.tandaVital = val;
  }
  bb = null;
  setBb(v) {
    this.bb = v;
  }
  tb = null;
  setTb(v) {
    this.tb = v;
  }
  bsa = null;
  msg = "";
  risikoJatuh = {
    id: null,
    risiko: null,
  };
  nyeri = {
    id: null,
    skala: 0,
    lokasi: "",
    durasi: null,
    frekuensi: null,
    pencetus: "",
    kualitas: "",
    pola_serangan: "",
    penyebab_hilang: "",
    jenis: "0",
  };
  getNyeri(val) {
    this.nyeri = val;
  }
  listDiagnosaKeperawatan = [
    { value: false, nama: "Nyeri Akut/Kronis", enable: true },
    { value: false, nama: "Cemas", enable: true },
    { value: false, nama: "Konstipasi", enable: true },
    { value: false, nama: "Sensori Persepsi", enable: true },
    { value: false, nama: "Kerusakan Integritas Kulit", enable: true },
    { value: false, nama: "Ketidakseimbangan Nutrisi", enable: true },
    { value: false, nama: "Mual/Muntah", enable: true },
    { value: false, nama: "Gangguan Mobilitas Fisik", enable: true },
    { value: false, nama: "Risiko Infeksi", enable: true },
    { value: false, nama: "Kurang Pengetahuan", enable: true },
  ];
  rencanaAsuhan = null;
  monitoringPasien = [
    {
      jam: null,
      tanda_vital: null,
      efek_samping: null,
      tindakan: null,
    },
  ];
  perawat = {};
  setPerawat(val) {
    this.perawat = val;
  }

  get stateuser() {
    return userModule.user;
  }
  get dataAsesmenKemoterapi() {
    return storeAsesmenKemoterapi.dataAsesmenKemoterapi;
  }
  get stateAsesmenAwal() {
    return storeAssesmenRalan.asesmenAwal;
  }
  get statePasien() {
    return storePasien.identitasPasien;
  }
  get asuransiNama() {
    const px = this.statePasien;
    return px && px.register && px.register.asr ? px.register.asr.nama : "-";
  }
  @Watch("statePasien")
  seedAlergiDariMaster(val) {
    if (this.id || this.alergi || !val) {
      return;
    }
    this.alergi = val.alergi;
  }
  get input() {
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: this.stateuser.unit_id,
      perawat_id: this.perawat["id"],
      waktu_periksa: this.waktuPeriksa,
      diagnosa: this.diagnosa,
      jenis_tindakan: this.tindakan == true || this.tindakan == "1" ? "1" : "0", // tindakan rawat jalan
      tindakan_ranap: this.ranap == true ? "1" : "0",
      siklus: this.siklus,
      alergi: this.alergi,
      keluhan_utama: this.keluhan,
      tanda_vital: this.tandaVital,
      status_gizi: {
        bb: this.bb,
        tb: this.tb,
        bsa: this.bsa,
      },
      risiko_jatuh: this.risikoJatuh,
      nyeri: this.nyeri,
      diagnosa_keperawatan: this.diagnosaKeperawatan,
      rencana_askep: this.rencanaAsuhan,
      monitoring_pasien: this.monitoringPasien,
    };
  }
  get diagnosaKeperawatan() {
    const list = this.listDiagnosaKeperawatan.filter(
      (val) => val.value == true
    );
    const data = [];
    for (let i = 0; i < list.length; i++) {
      data.push(list[i].nama);
    }
    return data;
  }

  timeRules = [
    (value) => !!value || "Jam tidak boleh kosong",
    (value) =>
      (value && this.validateTimeFormat(value)) || "Jam tidak sesuai format!",
  ];
  validateTimeFormat(timeStr: string) {
    const timeRegex = /^(0?[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/i;

    const match = timeStr.match(timeRegex);

    return match && match.length > 0;
  }
  simpan() {
    if (this.nyeri["skala"] == 0) {
      if (this.nyeri["id"]) {
        this.nyeri = {
          id: this.nyeri.id,
          skala: 0,
          lokasi: "",
          durasi: null,
          frekuensi: null,
          pencetus: "",
          kualitas: "",
          pola_serangan: "",
          penyebab_hilang: "",
          jenis: "0",
        };
      } else {
        this.nyeri = {
          id: null,
          skala: 0,
          lokasi: "",
          durasi: null,
          frekuensi: null,
          pencetus: "",
          kualitas: "",
          pola_serangan: "",
          penyebab_hilang: "",
          jenis: "0",
        };
      }
    }
    if (this.input.perawat_id) {
      this.loading = true;
      const save = this.id
        ? SvcAsesmenKemoterapi.put(this.id, this.input)
        : SvcAsesmenKemoterapi.post(this.input);
      save
        .then((dt) => {
          if (dt.data.status != 1) {
            appModule.sendErrorAlert(dt.data.message);
          } else {
            appModule.NoticeDelay(
              "Berhasil Menyimpan Data Asesmen Pasien Kemoterapi"
            );
            storeAsesmenKemoterapi.getAsesmenKemoterapiByReg(this.register);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      appModule.sendErrorAlert("Pastikan Kolom Petugas Pemeriksa Terisi");
    }
  }
  cetak() {
    SvcAsesmenKemoterapi.print(this.id);
  }
  mounted() {
    storeAsesmenKemoterapi.getAsesmenKemoterapiByReg(this.register);
    // RAL-032: tarik Asesmen Awal Ralan untuk prefill data bersama (TTV,
    // alergi, keluhan, BB/TB, nyeri, risiko jatuh).
    storeAssesmenRalan.actAsesmenAwal({
      unit_id: this.stateuser.unit_id,
      reg: this.register,
    });
  }

  // RAL-032: prefill dari Asesmen Awal Ralan. Hanya untuk asesmen kemo BARU
  // (belum ada record) dan hanya mengisi kolom yang masih kosong — input
  // perawat & record tersimpan tidak pernah ditimpa.
  @Watch("stateAsesmenAwal")
  prefillDariAsesmenAwal(val) {
    if (this.id || !val) {
      return;
    }
    if (!this.keluhan && val.anamnesis && val.anamnesis.keluhan) {
      this.keluhan = val.anamnesis.keluhan;
    }
    if (val.alergi) {
      this.alergi = val.alergi;
    }
    if (this.tandaVitalKosong() && val.tanda_vital) {
      this.tandaVital = { ...this.tandaVital, ...val.tanda_vital };
    }
    if ((!this.nyeri || this.nyeri.skala == 0) && val.nyeri) {
      this.nyeri = val.nyeri;
    }
    if (this.risikoJatuh.risiko == null && val.risiko_jatuh != null) {
      this.risikoJatuh = {
        ...this.risikoJatuh,
        risiko: Number(val.risiko_jatuh),
      };
    }
    if (!this.bb && val.antropometri && val.antropometri.berat_badan) {
      this.bb = val.antropometri.berat_badan;
    }
    if (!this.tb && val.antropometri && val.antropometri.tinggi_badan) {
      this.tb = val.antropometri.tinggi_badan;
    }
  }
  tandaVitalKosong() {
    const tv = this.tandaVital;
    return (
      !tv.sistole &&
      !tv.diastole &&
      !tv.frekuensi_nadi &&
      !tv.frekuensi_nafas &&
      !tv.suhu_badan &&
      !tv.saturasi_oksigen
    );
  }
  async ambilTtvTerakhir() {
    if (this.tarikTtvLoading || this.readOnly) {
      return;
    }
    this.tarikTtvLoading = true;
    try {
      const payload = await FormPrefillService.fetchPrefill(
        this.prefillRm,
        "asesmen_kemoterapi",
        {
          register_id: this.register,
          unit_id: this.stateuser.unit_id,
          sources: ["klinis_terkini"],
        }
      );
      const fields = (payload && payload.fields) || {};
      if (this.terapkanPrefill(fields) > 0) {
        appModule.NoticeDelay(
          "Tanda Vital & Status Gizi disalin dari " +
            this.labelSumber(payload) +
            "."
        );
        return;
      }
      if (this.terapkanAsesmenAwalRalan()) {
        appModule.NoticeDelay(
          "Tanda Vital & Status Gizi disalin dari Asesmen Awal Ralan."
        );
        return;
      }
      appModule.sendErrorAlert(
        "Belum ada catatan Tanda Vital untuk register ini. Isi Monitor TTV atau asesmen awal lebih dulu."
      );
    } finally {
      this.tarikTtvLoading = false;
    }
  }
  get prefillRm(): string {
    const px = this.statePasien;
    return String((px && px.rm) || this.rm || "");
  }
  labelSumber(payload) {
    const prov = (payload && payload.provenance) || {};
    const kunci = Object.keys(prov);
    for (let i = 0; i < kunci.length; i++) {
      const label = prov[kunci[i]] && prov[kunci[i]].source_label;
      if (label) {
        return label;
      }
    }
    return "catatan klinis terakhir register ini";
  }

  terapkanPrefill(fields): number {
    const isi = (kunci) => {
      const v = fields[kunci];
      return v === undefined || v === null || v === "" ? null : v;
    };
    const pilih = (baru, lama) => (baru === null ? lama : baru);
    const peta = [
      ["ttv.sistole", "sistole"],
      ["ttv.diastole", "diastole"],
      ["ttv.frekuensi_nadi", "frekuensi_nadi"],
      ["ttv.frekuensi_nafas", "frekuensi_nafas"],
      ["ttv.suhu_badan", "suhu_badan"],
      ["ttv.saturasi_oksigen", "saturasi_oksigen"],
      ["ttv.keadaan_umum", "keadaan_umum"],
      ["ttv.kesadaran", "kesadaran"],
    ];
    let terisi = 0;
    peta.forEach((pasangan) => {
      if (isi(pasangan[0]) !== null) {
        terisi++;
      }
    });
    if (terisi > 0) {
      this.tandaVital = {
        ...this.tandaVital,
        sistole: pilih(isi("ttv.sistole"), this.tandaVital.sistole),
        diastole: pilih(isi("ttv.diastole"), this.tandaVital.diastole),
        frekuensi_nadi: pilih(
          isi("ttv.frekuensi_nadi"),
          this.tandaVital.frekuensi_nadi
        ),
        frekuensi_nafas: pilih(
          isi("ttv.frekuensi_nafas"),
          this.tandaVital.frekuensi_nafas
        ),
        suhu_badan: pilih(isi("ttv.suhu_badan"), this.tandaVital.suhu_badan),
        saturasi_oksigen: pilih(
          isi("ttv.saturasi_oksigen"),
          this.tandaVital.saturasi_oksigen
        ),
        keadaan_umum: pilih(
          isi("ttv.keadaan_umum"),
          this.tandaVital.keadaan_umum
        ),
        kesadaran: pilih(isi("ttv.kesadaran"), this.tandaVital.kesadaran),
      };
    }
    if (isi("gizi.bb") !== null) {
      this.bb = isi("gizi.bb");
      terisi++;
    }
    if (isi("gizi.tb") !== null) {
      this.tb = isi("gizi.tb");
      terisi++;
    }
    return terisi;
  }
  terapkanAsesmenAwalRalan(): boolean {
    const src: any = this.stateAsesmenAwal;
    if (!src || !src.tanda_vital) {
      return false;
    }
    const s = src.tanda_vital;
    this.tandaVital = {
      ...this.tandaVital,
      sistole: s.sistole,
      diastole: s.diastole,
      frekuensi_nadi: s.frekuensi_nadi,
      frekuensi_nafas: s.frekuensi_nafas,
      suhu_badan: s.suhu_badan,
      saturasi_oksigen: s.saturasi_oksigen,
      keadaan_umum: s.keadaan_umum,
      kesadaran: s.kesadaran,
    };
    const a = src.antropometri;
    if (a) {
      if (a.berat_badan) {
        this.bb = a.berat_badan;
      }
      if (a.tinggi_badan) {
        this.tb = a.tinggi_badan;
      }
    }
    return true;
  }
  setDiagnosaKeperawatan(val) {
    this.listDiagnosaKeperawatan = [];
    this.listDiagnosaKeperawatan = [
      { value: false, nama: "Nyeri Akut/Kronis", enable: true },
      { value: false, nama: "Cemas", enable: true },
      { value: false, nama: "Konstipasi", enable: true },
      { value: false, nama: "Sensori Persepsi", enable: true },
      { value: false, nama: "Kerusakan Integritas Kulit", enable: true },
      { value: false, nama: "Ketidakseimbangan Nutrisi", enable: true },
      { value: false, nama: "Mual/Muntah", enable: true },
      { value: false, nama: "Gangguan Mobilitas Fisik", enable: true },
      { value: false, nama: "Risiko Infeksi", enable: true },
      { value: false, nama: "Kurang Pengetahuan", enable: true },
    ];
    for (let i = 0; i < val.length; i++) {
      if (
        val[i] != "Nyeri Akut/Kronis" &&
        val[i] != "Cemas" &&
        val[i] != "Konstipasi" &&
        val[i] != "Sensori Persepsi" &&
        val[i] != "Kerusakan Integritas Kulit" &&
        val[i] != "Ketidakseimbangan Nutrisi" &&
        val[i] != "Mual/Muntah" &&
        val[i] != "Gangguan Mobilitas Fisik" &&
        val[i] != "Risiko Infeksi" &&
        val[i] != "Kurang Pengetahuan"
      ) {
        this.listDiagnosaKeperawatan.push({
          value: true,
          nama: val[i],
          enable: false,
        });
      } else {
        for (let j = 0; j < this.listDiagnosaKeperawatan.length; j++) {
          if (val[i] == this.listDiagnosaKeperawatan[j].nama) {
            this.listDiagnosaKeperawatan[j].value = true;
          }
        }
      }
    }
  }
  addMonitoring() {
    const dt = {
      jam: null,
      tanda_vital: null,
      efek_samping: null,
      tindakan: null,
    };
    this.monitoringPasien.push(dt);
  }
  hapusMonitoring(idx) {
    this.monitoringPasien.splice(idx, 1);
  }
  tambahDiagnosa() {
    const dt = { value: true, nama: "", enable: false };
    this.listDiagnosaKeperawatan.push(dt);
  }
  message() {
    return this.msg;
  }

  @Watch("dataAsesmenKemoterapi")
  watchAsesmen(val) {
    if (val) {
      this.id = val.id;
      this.waktuPeriksa = val.waktu_periksa;
      this.diagnosa = val.diagnosa;
      this.tindakan = val.jenis_tindakan == "1" ? true : false; // tindakan rawat jalan
      this.ranap = val.tindakan_ranap
        ? val.tindakan_ranap == "1"
          ? true
          : false
        : null;
      this.siklus = val.siklus;
      this.keluhan = val.keluhan_utama;
      this.alergi = val.alergi ? val.alergi.alergi : null;
      this.tandaVital = val.tanda_vital
        ? val.tanda_vital
        : {
            id: null,
            sistole: null,
            diastole: null,
            frekuensi_nadi: null,
            frekuensi_nafas: null,
            suhu_badan: null,
            saturasi_oksigen: null,
            keadaan_umum: "",
            kesadaran: "",
          };
      this.risikoJatuh = val.risiko_jatuh
        ? val.risiko_jatuh
        : {
            id: null,
            risiko: null,
          };
      this.bb = val.status_gizi.bb;
      this.tb = val.status_gizi.tb;
      this.bsa = val.status_gizi.bsa;
      this.nyeri = val.nyeri
        ? val.nyeri
        : {
            id: null,
            skala: 0,
            lokasi: "",
            durasi: null,
            frekuensi: null,
            pencetus: "",
            kualitas: "",
            pola_serangan: "",
            penyebab_hilang: "",
            jenis: "0",
          };
      this.setDiagnosaKeperawatan(val.diagnosa_keperawatan);
      this.rencanaAsuhan = val.rencana_askep;
      this.monitoringPasien = val.monitoring_pasien;
      this.perawat = val.perawat;
    } else {
      this.id = null;
    }
  }
  @Watch("bb")
  watchBb(v) {
    this.setBsa();
  }
  @Watch("tb")
  watchTb(v) {
    this.setBsa();
  }
  setBsa() {
    if (!this.tb && !this.bb) {
      this.bsa = null;
    } else if (this.bb < 1 || this.tb < 1) {
      this.bsa = null;
    } else {
      this.bsa = Math.sqrt((Number(this.bb) * Number(this.tb)) / 3600).toFixed(
        2
      );
    }
  }
}
